import { Observable } from 'rxjs';

import EmailTemplate from '../interfaces/email-template';
import { HttpClient } from './http-client';

export class EmailTemplateService extends HttpClient {
  index(): Observable<EmailTemplate[]> {
    return this.get<EmailTemplate[]>('/api/internal/email-templates');
  }

  show(id: string): Observable<EmailTemplate> {
    return this.get<EmailTemplate>(`/api/internal/email-templates/${id}`);
  }

  update(id: string, emailTemplate: EmailTemplate): Observable<EmailTemplate> {
    return this.put<EmailTemplate>(
      `/api/internal/email-templates/${id}`,
      emailTemplate
    );
  }
}
